<script setup>
import { ref, computed, onMounted } from 'vue'
import Card from 'primevue/card'
import Badge from 'primevue/badge'
import { useConversationsStore } from '@/stores/messages/conversations.js'
import ChatThread from './ChatThread.vue'

const conv = useConversationsStore()
const activeId = ref(null)
const items = computed(() => conv.sorted)

function toggle(c) {
  if (activeId.value === c.id) {
    activeId.value = null
    conv.setActive(null)
  } else {
    activeId.value = c.id
    conv.setActive(c.id)
    const found = conv.items.find(x => x.id === c.id)
    if (found) found.unread_count = 0
  }
}

function previewBody(text, max = 80) {
  const s = (text ?? '').toString().trim()
  return s.length > max ? s.slice(0, max) + '…' : s
}

// Скролл-контейнер и догрузка
const scrollContainer = ref(null)
let isFetchingMore = false
async function tryLoadMore() {
  if (isFetchingMore || tasks.loading || !tasks.page.next) return
  isFetchingMore = true
  try { await tasks.listNext() } finally { isFetchingMore = false }
}
function onScroll() {
  const el = scrollContainer.value
  if (!el) return
  const threshold = 120
  const nearBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - threshold
  if (nearBottom) tryLoadMore()
}
onMounted(() => conv.fetchConversations())
</script>

<template>
  <Card>
    <template #title>Сообщения</template>
    <template #content>
      <div ref="scrollContainer" class="flex-1 min-h-0 overflow-auto" style="height: calc(100vh - 280px)">

      <div v-for="c in items" :key="c.id" class="px-2 py-1">
          <div
              class="flex items-center justify-between gap-2 p-2 rounded cursor-pointer hover:bg-surface-100"
              @click="toggle(c)"
          >
            <div class="flex flex-col">
              <span class="font-semibold flex items-center gap-2">
                <span>
                  {{ c.thread_entity_title || c.title || c.other_user?.name || ('Диалог #' + c.id) }}
                </span>
                <RouterLink
                  v-if="c.thread_entity_url"
                  :to="c.thread_entity_url"
                  class="text-xs text-gray-500 hover:text-gray-700"
                  @click.stop
                >
                  <i class="pi pi-link"></i>
                </RouterLink>
              </span>
              <span class="text-xs text-gray-500 truncate max-w-[260px]">
                {{ previewBody(c.last_message?.body) }}
              </span>
            </div>
            <Badge v-if="c.unread_count" :value="c.unread_count" severity="info" size="small" />
          </div>

          <div v-if="activeId === c.id" class="mt-2 ml-3 pl-3 border-l border-surface-200">
            <ChatThread :conversation-id="activeId" />
          </div>
        </div>
      </div>
    </template>
  </Card>
</template>
